import * as React from 'react';

import { domainTableHeadersLine } from './DomainTableHeader';

export function BlankHeaderCell() {
    return (
        <th className={domainTableHeadersLine} />
    );
}
